import React, { useState } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import {
  Box,
  Typography,
  Grid,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Card,
  CardMedia,
  CardContent,
  Snackbar,
  Alert
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { vendorApi } from "../../api/api";
import ApprovePropertyByTeam from "../legalteam/ApprovePropertyByTeam";
import { useSelector } from "react-redux";
import ApprovePropertyByAdmin from "./ApprovePropertyByAdmin";

const ApproveProperty = () => {
  const role=useSelector((state)=>state.user.role);
  const navigate = useNavigate();
  const location = useLocation();
  const propertyData = location.state;

  const [openSnackbar, setOpenSnackbar] = useState(false);
 

  

  const [status, setStatus] = useState("Approved");

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };

  const formData = new FormData();
  formData.append("propertyId", propertyData.id);
  formData.append("Status", status);


  const handleViewProject = () => {
    if (Number(propertyData?.PropertyType) === 1) {
      navigate(`/viewProject/viewProject?projectId=${propertyData.ProjectId}`, {
        state: {
          ProjectId: propertyData.ProjectId,
          ProjectName: propertyData.ProjectName,
          City: propertyData.City,
          Address: propertyData.Address,
          NoOfPlots: propertyData.NoOfPlots,
          IconUrl: propertyData.IconUrl,
        },
      });
    }
    else if ((Number(propertyData?.PropertyType)) === 2 || Number(propertyData?.PropertyType) === 4
) {
  navigate(`/property/viewProperty?propertyId=${propertyData.id}`, {
    state: {
      PropertyId: propertyData.id,
    },
  });
}
else if(Number(propertyData?.PropertyType) === 3){
  navigate(`/apartment/viewApartment?propertyId=${propertyData.id}`, {
    state: {
      PropertyId: propertyData.id,
    },
  });
}
  };
  const type = propertyData?.PropertyType;

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Property Details
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box
            sx={{
              p: 3,
              borderRadius: 2,
              boxShadow: 3,
              backgroundColor: "white",
              position: "relative", 
            }}
          >
            {propertyData?.PropertyType === "3" && 
             <Typography variant="h5" sx={{ color: "#1976d2", fontWeight: "bold", mb: 2 }}>
              {propertyData?.ApartmentName}
            </Typography>
}

            {/* Property Name with unique style */}
            <Typography variant="h5" sx={{ color: "#1976d2", fontWeight: "bold", mb: 2 }}>
              {propertyData?.PropertyName}
            </Typography>

            {/* Address and City with a single location icon */}
            <Box sx={{ display: "flex", alignItems: "flex-start" }}>
              <LocationOnIcon sx={{ color: "black", mr: 2, mt: 0.5, fontSize: "2rem" }} />
              <Box>
                <Typography variant="body1">{propertyData?.Address}</Typography>
                <Typography variant="body1">{propertyData?.City}</Typography>
              </Box>
            </Box>

            {/* Conditionally Render the "View Project Details" Button */}
          

<Button
  variant="contained"
  sx={{
    position: "absolute",
    top: 16,
    right: 16,
    background: "linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)",
    color: "white",
    px: 2,
    py: 0.5,
    borderRadius: 3,
    fontWeight: "bold",
    textTransform: "none",
    boxShadow: "0 3px 5px 2px rgba(33, 203, 243, .3)",
    "&:hover": {
      background: "linear-gradient(45deg, #1E88E5 30%, #00ACC1 90%)",
    },
  }}
  onClick={handleViewProject}
>
  {
    type === 1 ? "View Project Details" :
    type === 2 ? "View Property Details" :
    type === 3 ? "View Apartment Details" :
    type === 4 ? "View Villa Details" :
    "View Details"
  }
</Button>

          </Box>
        </Grid>
         </Grid>
         { role=='legalteam' ?
        
         <ApprovePropertyByTeam/> : <ApprovePropertyByAdmin/>
}
</Box>


        
   
  );
};

export default ApproveProperty;
